import * as React from 'react';
import * as styles from './CarouselTour.css';
import { TourPlaceholder } from '../../../TourPlaceholder';

interface ICarouselTourProps {
  src: string;
}

export const CarouselTour = React.memo(({ src }: ICarouselTourProps) => {
  return (
    <div className={styles['container']}>
      <img className="lazyload" data-src={src} />
      <div className={styles['content']}>
        <TourPlaceholder />
      </div>
    </div>
  );
});

CarouselTour.displayName = 'CarouselTour';
